import { render, staticRenderFns } from "./ChannelOrderState.vue?vue&type=template&id=7140e3ad&scoped=true"
import script from "./ChannelOrderState.vue?vue&type=script&lang=js"
export * from "./ChannelOrderState.vue?vue&type=script&lang=js"
import style0 from "./ChannelOrderState.vue?vue&type=style&index=0&id=7140e3ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140e3ad",
  null
  
)

export default component.exports